var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import * as luxon from 'luxon';
import { useSmartCheckCommonStyles } from './SmartCheckLightBeforeUseTemplate';
import { Container, CssBaseline, Grid, Typography } from '@material-ui/core';
import { CouponName } from '../../organisms/CouponName';
import { ProductImage } from '../../organisms/ProductImage';
import { Description } from '../../organisms/Description';
import { CompanyImage } from '../../organisms/CompanyImage';
import { SmartCheckHeaderImage } from '../../organisms/SmartCheckHeaderImage';
import { SmartCheckUsedImage } from '../../organisms/SmartCheckUsedImage';
import { CompanyName } from '../../organisms/CompanyName';
/**
 * SmartCheckカウントダウン画面テンプレート
 */
export var SmartCheckLightAfterUsedTemplate = function (props) {
    var _a, _b, _c;
    var classes = useSmartCheckCommonStyles();
    return (React.createElement(Container, { disableGutters: true },
        React.createElement(CssBaseline, null),
        React.createElement(Grid, { container: true, justifyContent: "center", alignItems: "center" },
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CompanyImage, { imageUrl: props.data.companyImageUrl })),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(SmartCheckHeaderImage, { imageUrl: (_a = props.data.smartCheckImageUrl) === null || _a === void 0 ? void 0 : _a.smartCheckHeaderImageUrl })),
            props.layoutPattern === 'normal' || props.layoutPattern === 'product' ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CompanyName, __assign({}, props.data.organizationName)))) : (React.createElement(React.Fragment, null)),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(CouponName, __assign({}, props.data.couponName))),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { className: classes.smartCheckUsedAt, variant: "h4" },
                    "\u5229\u7528\u65E5\u6642\uFF1A",
                    luxon.DateTime.fromISO(props.data.smartCheckUsedAt).toFormat('yyyy/MM/dd HH:mm'))),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { className: props.layoutPattern === 'bigShopName' ? classes.countDownAfterBigShopNameTemplate : classes.countDownAfter, variant: "h3" }, "\u3053\u306E\u30AF\u30FC\u30DD\u30F3\u306F\u4F7F\u7528\u6E08\u307F\u3067\u3059")),
            ((_b = props.data.smartCheckImageUrl) === null || _b === void 0 ? void 0 : _b.smartCheckUsedImageUrl) ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(SmartCheckUsedImage, { imageUrl: (_c = props.data.smartCheckImageUrl) === null || _c === void 0 ? void 0 : _c.smartCheckUsedImageUrl }))) : props.data.productImage ? (React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(ProductImage, __assign({}, props.data.productImage)))) : (React.createElement(React.Fragment, null)),
            React.createElement(Grid, { item: true, xs: 12, className: classes.section },
                React.createElement(Typography, { align: "right", variant: 'body1' }, props.data.barcode.barcodeValue))),
        React.createElement(Description, __assign({}, props.data.description)),
        React.createElement(Grid, { item: true, xs: 12, className: classes.section },
            React.createElement(Typography, { align: "center", variant: "body2" },
                "\u5229\u7528\u65E5\u6642\uFF1A",
                luxon.DateTime.fromISO(props.data.smartCheckUsedAt).toFormat('yyyy/MM/dd HH:mm')))));
};
//# sourceMappingURL=SmartCheckLightAfterUsedTemplate.js.map